// extracted by mini-css-extract-plugin
export default {"mobile_code_data":"mobileCodeData_mobile_code_data__jmMbv","loading":"mobileCodeData_loading__XLq+S","label":"mobileCodeData_label__aGM3a","field":"mobileCodeData_field__XP1SU"};